//export const API_BASE_URL = 'http://usc.local:8000/api/';
//export const BASE_URL = 'http://usc.local:8000/uploads/';
//export const API_BASE_URL = 'https://weloveitstudio.info/USC-Elevator/admin/api/';
//export const BASE_URL = 'https://weloveitstudio.info/USC-Elevator/admin/uploads/';

export const API_BASE_URL = 'https://elevinteriors.com/admin/api/';
export const BASE_URL = 'https://elevinteriors.com/admin/uploads/';


// WEBPACK FOOTER //
// ./src/config.js